import React, { useEffect, useState } from 'react'
import { useTranslation } from '../../../locale/useTranslation';
import * as API from '../../../framework/API/api';
import ActionButton from '../../../framework/forms/helpercomponents/buttons/ActionButton';
import { COLUMNSTYPE, ENTITYNAME, FILEURL, LOCALSTORAGE_KEY, MAM_STATUS, TOAST_TYPES, TRANSMISSION_PUBLISH_STATUS } from '../../../framework/constant/constant';
import { Grid, GridColumn } from '@progress/kendo-react-grid';
import { DateCell, DateOnlyCell, LocalDateTimeColumn } from '../../../framework/forms/helpercomponents/CustomGridCells/DateCell';
import { TimeCell } from '../../../framework/forms/helpercomponents/CustomGridCells/TimeCell';
import { ImageCell } from '../../../framework/forms/helpercomponents/CustomGridCells/ImageCell';
import { CheckboxCell } from '../../../framework/forms/helpercomponents/CustomGridCells/CheckBoxCell';
import { ArrayCell } from '../../../framework/forms/helpercomponents/CustomGridCells/ArrayCell';
import { HrefCell, HyperLinkCell } from '../../../framework/forms/helpercomponents/CustomGridCells/HrefCell';
import { EnumCell, SIDEnumCell } from '../../../framework/forms/helpercomponents/CustomGridCells/EnumCell';
import { arrayEnumCell, PlatformCell } from '../../../framework/forms/helpercomponents/CustomGridCells/PlatformCell';
import { colorCell } from '../../../framework/forms/helpercomponents/CustomGridCells/ColorCell';
import { TextWithIconCell } from '../../../framework/forms/helpercomponents/CustomGridCells/TextWithIconCell';
import { utility } from '../../../framework/utility/utilityProvider';
import { LookupCell } from '../../../framework/forms/helpercomponents/CustomGridCells/LookupCell';
import MyStatusCell from '../../../components/MyStatusCell';
import { Loader } from '../../../framework/forms/helpercomponents/Loader';
import MAMStatusCell from '../../../components/MAMStatusCell';
import ToastNotification from '../../../components/ToastNotification';

const DublistReportCollection = () => {

    const lang = useTranslation();
    const [gridData, setGridData] = useState([]);
    const [total, setTotal] = useState(0);
    const [page, setPage] = useState({ skip: 0, take: 50 });
    const [columns, setColumns] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        loadData({ pagination: { per_page: page.take, current_page: 1 } });
    }, []);

    const loadData = async ({ pagination }) => {
        setIsLoading(true);
        // Load column
        let currentUserId = utility.getValue(LOCALSTORAGE_KEY.user_id);
        let columnRes = await API.getFormData(ENTITYNAME.MediaMamAssets, currentUserId) ?? [];
        setColumns(columnRes);
        // Load data
        const payload = {
            isExport: false,
            page: pagination.current_page,
            perPage: pagination.per_page
        }
        let res = await API.exportDublistReport(payload);
        console.log(res);
        if (res.success) {
            setTotal(res?.pagination?.total);
            setGridData(res.data);
        } else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
        }
        setIsLoading(false);
    }

    const borderStyle = {
        border: "1px solid #ced4da",
        boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
        backgroundColor: "#FAFAFA"
    }

    const handleExport = async () => {
        const payload = {
            isExport: true,
        }
        let res = await API.exportDublistReport(payload);
        console.log(res);
        if (res.success) {
            window.open(FILEURL().BASEURL + 'downloadReport/' + res.data);
            ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: lang.successfully_exported_success_message });
        }
        else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
        }
    }

    const pageChange = async (e) => {
        let current_page = e.page.skip / e.page.take + 1;
        setPage(e.page);
        await loadData({ pagination: { per_page: e.page.take, current_page: current_page } });
    };

    const MyDatalookupCell = (props) => (
        <LookupCell {...props} dataColumns={columns} />
    );

    return (
        <div className='m-1'>
            <h1 className="page-title txt-color-bludeDark">
                <i className="fa fa-table marlr" style={{ fontSize: 20, color: 'GrayText' }} />
                <span>{lang.dublist_report_page_breadcrumb} ({total})</span>
            </h1>
            <div className="border p-2 form-group with-3d-effect" style={borderStyle}>
                <ActionButton title={lang.export_button_tooltip} name={lang.export_button_text} onClick={handleExport} />
                <hr />
                {isLoading ? <Loader /> :
                    <Grid
                        style={{ height: 'calc(100vh - 210px)' }}
                        sortable={true}
                        pageable={true}
                        skip={page.skip}
                        take={page.take}
                        onPageChange={pageChange}
                        total={total}
                        resizable={true}
                        data={gridData}
                    >
                        {columns.map((column, index) => {
                            if (column.type === COLUMNSTYPE.date) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={DateOnlyCell}
                                        title={column.label}
                                        width={column.width ?? 200}
                                        sortable={true}
                                    />
                                );
                            } else if (column.type === COLUMNSTYPE.datetime) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={DateCell}
                                        title={column.label}
                                        width={column.width ?? 200}
                                        sortable={true}
                                    />
                                );
                            } else if (column.name.includes("Duration") || column.type == COLUMNSTYPE.time) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={TimeCell}
                                        title={column.label}
                                        width={column.width ?? 200}
                                        sortable={true}
                                    />
                                );
                            } else if (column.type === COLUMNSTYPE.image) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={(p) => ImageCell({ ...p, title: column.label })}
                                        title={column.label}
                                        width={column.width ?? 100}
                                        sortable={false}
                                    />
                                );
                            } else if (column.name === "Status" && column.type == COLUMNSTYPE.mamAssetStatusCell) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={MAMStatusCell}
                                        title={column.label}
                                        width={column.width ?? 200}
                                        sortable={false}
                                    />
                                );
                            }
                            else if (column.type === COLUMNSTYPE.select) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={MyDatalookupCell}
                                        title={column.label}
                                        width={column.width ?? 200}
                                        sortable={false}
                                    />
                                );
                            }
                            else if (column.type === COLUMNSTYPE.checkbox) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={CheckboxCell}
                                        title={column.label}
                                        width={column.width ?? 80}
                                        sortable={false}
                                    />
                                );
                            }
                            else if (column.type === COLUMNSTYPE.array) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={ArrayCell}
                                        title={column.label}
                                        width={column.width ?? 200}
                                        format={column.format ?? "Description"}
                                        sortable={false}
                                    />
                                );
                            }
                            else if (column.type === COLUMNSTYPE.href) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={HrefCell}
                                        title={column.label}
                                        width={column.width ?? 200}
                                        format={column.format}
                                        sortable={false}
                                    />
                                );
                            }
                            else if (column.type === COLUMNSTYPE.hyperlink) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={HyperLinkCell}
                                        title={column.label}
                                        width={column.width ?? 200}
                                        format={column.format}
                                        sortable={false}
                                    />
                                );
                            }
                            else if (column.type === COLUMNSTYPE.enum) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={EnumCell}
                                        title={column.label}
                                        width={column.width ?? 200}
                                        format={column.format ?? "Description"}
                                        sortable={true}
                                    />
                                );
                            } else if (column.type === COLUMNSTYPE.platform) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={PlatformCell}
                                        title={column.label}
                                        width={column.width ?? 200}
                                        sortable={false}
                                    />
                                );
                            }
                            else if (column.type === COLUMNSTYPE.localdatetime) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={LocalDateTimeColumn}
                                        title={column.label}
                                        width={column.width ?? 200}
                                        sortable={true}
                                    />
                                );
                            }
                            else if (column.type === COLUMNSTYPE.arrayenum) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={arrayEnumCell}
                                        title={column.label}
                                        width={column.width ?? 80}
                                        sortable={false}
                                    />
                                );
                            }
                            else if (column.type === COLUMNSTYPE.color) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={colorCell}
                                        title={column.label}
                                        width={column.width ?? 80}
                                        sortable={false}
                                    />
                                );
                            }
                            else if (column.type === COLUMNSTYPE.textWithIcon) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={TextWithIconCell}
                                        title={column.label}
                                        width={column.width ?? 200}
                                        sortable={false}
                                    />
                                );
                            }
                            else if (column.type === COLUMNSTYPE.SIDEnum) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={(props) => SIDEnumCell({ ...props, fk_entityName: column.fk_entityName, fk_field: column.fk_field })}
                                        title={column.label}
                                        width={column.width ?? 80}
                                    />
                                );
                            }
                            else {
                                return (
                                    column.type !== COLUMNSTYPE.hidden && (
                                        <GridColumn
                                            key={index}
                                            field={column.name}
                                            title={column.label}
                                            width={column.width ?? 200}
                                            sortable={true}
                                        />
                                    )
                                );
                            }
                        })}
                    </Grid>}
            </div>
        </div>
    )
}

export default DublistReportCollection;